export default {
  preferences: {
    title: "Preferencias",
    promo: {
      blurb: "Jugadas avanzadas.\nAnálisis más profundos.",
    },
    sections: {
      account: "Cuenta",
      display: "Pantalla",
      support: "Soporte",
      about: "Acerca de",
    },
    items: {
      profile: "Perfil",
      location: "Ubicación",
      manageSubscription: "Administrar suscripción",
      glossary: "Glosario",
      contactSupport: "Contactar soporte",
      logOut: "Cerrar sesión",
      deleteAccount: "Eliminar cuenta",
    },
    profile: {
      title: "Perfil",
      alerts: {
        passwordMessage: "Para cambiar tu contraseña, visita linemate.io",
        usernameInvalid: "Tu nombre de usuario debe tener al menos 6 caracteres. Solo debe incluir letras y números.",
        usernameTaken: "Ese nombre de usuario ya está en uso",
      },
      saved: "Perfil guardado",
    },
    display: {
      preferences: {
        theme: "Tema",
        odds: "Cuotas",
        language: "Idioma",
      },
      options: {
        theme: {
          "Match System": "Coincidir con el sistema",
          Light: "Claro",
          Dark: "Oscuro",
        },
        odds: {
          american: "Americana",
          decimal: "Decimal",
        },
      },
    },
    language: {
      loading: "Actualizando idioma...",
    },
    about: {
      terms: "Términos",
      privacy: "Privacidad",
      responsibleGambling: "Juego responsable",
      openSourceLibraries: "Bibliotecas de código abierto",
      acknowledgments: "Agradecimientos",
    },
    subscription: {
      alertTitle: "Suscripción",
      webMessage: "Para administrar tu suscripción, visita la sección de perfil en linemate.io",
      googlePlayMessage: "Para administrar tu suscripción, visita la sección de Suscripciones de tu cuenta de Google Play Store asociada con esta compra",
      appleMessage: "Para administrar tu suscripción, visita la sección de Suscripciones de tu cuenta de Apple asociada con esta compra",
      manageTitle: "Administrar suscripción",
      currentPlan: "Plan actual",
      changePlan: "Cambiar plan",
      cancelPlan: "Cancelar suscripción",
      cancelTitle: "Cancelar suscripción",
      cancelHeading: "¿Por qué estás cancelando?",
      cancelSubtitle: "Tus comentarios nos ayudarán a mejorar nuestro producto.",
      missingTitle: "¿Qué falta?",
      missingSubtitle: "¿Qué funciones o herramientas harían que Linemate te resultara más útil?",
      improveTitle: "Cuéntanos cómo mejorar",
      improveSubtitle: "Tus comentarios nos ayudan a mejorar.",
      trialActive: "Tu prueba de Linemate+ sigue activa.",
      alreadyActive: "Ya tienes acceso a Linemate+",
      exclusiveOfferFallbackTitle: "Oferta exclusiva",
      exclusiveOfferFallbackSubtitle: "Mantén tu acceso con una oferta por tiempo limitado antes de cancelar.",
      claimOneTimeOffer: "Reclamar oferta única",
      offerApplyFailure: "No pudimos aplicar esta oferta ahora. Inténtalo de nuevo más tarde.",
      continueToCancel: "Continuar con la cancelación",
      losingAccessTitle: "Perderás acceso a nuestras funciones avanzadas más recientes",
      losingAccessSubtitle: "Esto es lo que perderás cuando termine tu plan.",
      keepSubscription: "Mantener suscripción",
      feedbackPlaceholder: "Ingresa tu respuesta...",
    },
    providers: {
      locationTitle: "Permite que Linemate acceda a tu ubicación para establecer tus cuotas preferidas",
      locationSubtitle: "Linemate usa tu ubicación para mostrar proveedores en tu zona",
    },
    location: {
      title: "Ubicación",
      useCurrentLocation: "Usar ubicación actual",
      enableLocationMessage: "Ahorra tiempo y permite compartir tu ubicación para que podamos mostrarte los mejores mercados y ofertas.",
    },
    logout: {
      title: "Cerrar sesión",
      message: "¿Seguro que quieres cerrar sesión?",
    },
    deleteAccount: {
      warningTitle: "Advertencia",
      warningMessage: "Actualmente tienes una suscripción activa. Tendrás que cancelarla antes de eliminar tu cuenta.",
      confirmTitle: "Eliminar cuenta",
      confirmMessage: "¿Seguro que quieres eliminar tu cuenta?",
      confirmAction: "Eliminar",
      successTitle: "Eliminar cuenta",
      successMessage: "Tu cuenta se eliminó correctamente.",
      errorTitle: "Error",
    },
    communication: {
      title: "Comunicación",
      email: "Correo electrónico",
      emailDescription: "Correos de marketing, actualizaciones de investigación, novedades del producto y anuncios ocasionales de la plataforma.",
      notificationSettings: "Configuración de notificaciones",
      notificationDescription: "Notificaciones de marketing, recordatorios antes de ventanas importantes de partidos y novedades sobre nuevas funciones.",
    },
    feedback: {
      title: "Compartir comentarios",
      enjoymentPrompt: "¿Estás disfrutando tu experiencia?",
      improvePrompt: "Cuéntanos cómo podemos mejorar. Cada comentario ayuda.",
      actions: {
        yes: "Sí",
        no: "No",
        contactUs: "Contáctanos",
        notNow: "Ahora no",
      },
      communication: {
        title: "Comunicación",
        email: "Correo electrónico",
        emailDescription: "Correos de marketing, actualizaciones de investigación, novedades del producto y anuncios ocasionales de la plataforma.",
        notificationSettings: "Configuración de notificaciones",
        notificationDescription: "Notificaciones de marketing, recordatorios antes de ventanas clave de partidos y novedades sobre funciones nuevas.",
      },
    },
  },
};
